import { Injectable } from '@angular/core';
import { ConfigLoaderService } from '../../services/api-services/configLoader.service';
import { ElementsConfig } from 'src/app/pages/user-details/config/user-data.config';

@Injectable({
  providedIn: 'root'
})
export class StorageConfigService {

  phoneMap: Record<string, string> = {
    'ReAssure': '0800 008 3034',
    'Phoenix Life': '0800 316 3062'
  };
  sourceList:any[] = ElementsConfig.sourcesListCvt;
  constructor(private configLoaderService: ConfigLoaderService) { }

  showWarningText() {
    const today = new Date();
    const terminationDate = new Date(this.configLoaderService.configuration.terminationDate);

    // Calculate one month before termination date
    const warningStartDate = new Date(terminationDate);
    warningStartDate.setMonth(warningStartDate.getMonth() - 1);
    return (this.configLoaderService.configuration.isSourceTerminated && today >= warningStartDate && today < terminationDate);
  }

  isTerminationActive() {
    const today = new Date();
    return this.configLoaderService.configuration.isSourceTerminated && (today >= new Date(this.configLoaderService.configuration.terminationDate));
  }

  getWaringText(warningText: string, sourceCode: string) {
    const sourceObj = this.sourceList.find(fund => fund.fundProvider === sourceCode);
    return (warningText.replace(/{}/g, sourceObj['value'])).replace(/0800\s\d{3}\s\d{4}/, this.phoneMap[sourceObj['value']] ?? '0800 000 0000');
  }
}
